import { connect } from "react-redux";
import { default as component } from "./AddContentOrderToBoxFolder.jsx";

// Global selectors and actions
import { getActiveModal } from "../../../../common/UI/ActiveModal/duck/selectors";
import { dismissModal } from "../../../../common/UI/ActiveModal/duck/actions";

// Local selectors and actions
import {
  toggleSubmitLocked,
  updateContentsForBoxUpload,
  setFocusedContentOrderForUploadingToBox,
  uploadContentsToBox,
} from "./duck/actions";

import {
  getSubmissionStatus,
  getFocusedContentOrderSubmitLockedStatus,
  getFocusedContentOrderDetails,
  getFocusedContentOrderPreview,
  getFocusedContentOrderNewBoxHTML,
} from "./duck/selectors";

const mapStateToProps = (state) => {
  return {
    submissionStatus: getSubmissionStatus(state),
    submitLocked: getFocusedContentOrderSubmitLockedStatus(state),
    activeModal: getActiveModal(state),
    contentOrder: getFocusedContentOrderDetails(state),
    contents: getFocusedContentOrderNewBoxHTML(state),
    preview: getFocusedContentOrderPreview(state),
  };
};

const mapDispatchToProps = {
  dismissModal,
  toggleSubmitLocked,
  setFocusedContentOrderForUploadingToBox,
  uploadContentsToBox,
  updateContentsForBoxUpload,
};

export default connect(mapStateToProps, mapDispatchToProps)(component);
